import { ActionCreatorWithPayload } from '@reduxjs/toolkit'

export default class SagaActionEnabledError extends Error {
    public actionToCall: ActionCreatorWithPayload<string, string>
    constructor(action: ActionCreatorWithPayload<string, string>, message: string) {
        super(message)
        this.actionToCall = action
    }
}
